import { render, staticRenderFns } from "./white-list.vue?vue&type=template&id=655ca984&scoped=true&"
import script from "./white-list.vue?vue&type=script&lang=js&"
export * from "./white-list.vue?vue&type=script&lang=js&"
import style0 from "./white-list.vue?vue&type=style&index=0&id=655ca984&prod&lang=stylus&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "655ca984",
  null
  
)

export default component.exports